import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ReactCardFlip from "react-card-flip";
import axios from 'axios';
import '../../common/WithUi/SubscriptionAuth.css';
import config from "../../../config/Global.json";
import useFormattedDate from "../../../context/useFormattingUtils";
import PaymentComponent from '../WithUi/PaymentComponent';
import infoIcon from '../../../assets/Image/info.png';
import infoDark from '../../../assets/SubscriptionImage/info_dark.png';
import CartIcon from '../../../assets/SubscriptionImage/add-to-cart (1) 7.png';
import RemoveIcon from '../../../assets/SubscriptionImage/minus-button 2.png'
import ChequeIcon from '../../../assets/SubscriptionImage/Cheque.png';
import GasIcon from '../../../assets/SubscriptionImage/Gas.png';
import LotteryIcon from '../../../assets/SubscriptionImage/Lottery.png';
import PosIcon from '../../../assets/SubscriptionImage/Pos.png';
import GeneralIcon from '../../../assets/SubscriptionImage/General.png';
import ExpenseIcon from '../../../assets/SubscriptionImage/expense.png';
import InventoryIcon from '../../../assets/SubscriptionImage/Inventory.png';
import SaleIcon from '../../../assets/SubscriptionImage/Sale.png';
import PayrollIcon from '../../../assets/SubscriptionImage/Payroll.png';
import TimeCardIcon from '../../../assets/SubscriptionImage/TimeCard.png';
import ArrowDownIcon from '../../../assets/SubscriptionImage/downIcon.png';
import Cart from '../../../assets/SubscriptionImage/trolley (1) 1.png'
import LegalIcon from '../../../assets/SubscriptionImage/LegalApp.png'
import CameraIcon from '../../../assets/SubscriptionImage/CameraIcon.jpg'
import EcommerceLogo from "../../../assets/SubscriptionImage/e-com.png"
import AssetsLogo from "../../../assets/img/logo-image/assets.png"

const generateSafeId = (name) => {
  return name?.toString().trim().toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-_]/g, "") || "";
};

function SubscriptionComponent({ inModal = false, onProceedToPayment }) {
    const [selectedModules, setSelectedModules] = useState([]);
    const [modules, setModules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [flippedCards, setFlippedCards] = useState({});
    const [moduleSelectedMonths, setModuleSelectedMonths] = useState({});
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [selectedModuleData, setSelectedModuleData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const { formatCurrency } = useFormattedDate();
    const navigate = useNavigate();
    const location = useLocation();
    const storeId = location.state?.storeId;

    const fetchModules = async () => {
        const apiUrl = `${config.api.host}${config.api.featuresWithPrices}`;
        try {
            const response = await axios.get(apiUrl);
            const data = response.data;

            if (data && data.length > 0) {
                const transformedModules = data
                    .filter(item => item.enable)
                    .map(item => {
                        const defaultPriceDetail = item.price_details[0] || {};
                        return {
                            name: item.title,
                            description: item.description || 'No description available',
                            price_details: item.price_details,
                            icon: item.icon,
                            id: item.id,
                            defaultPrice: defaultPriceDetail.total_price || '0.00'
                        };
                    });

                setModules(transformedModules);

                const initialFlippedState = {};
                const initialMonthsState = {};
                transformedModules.forEach(module => {
                    initialFlippedState[module.id] = false;
                    const defaultMonths = module.price_details.find(p => p.no_of_months === 1)?.no_of_months || module.price_details[0]?.no_of_months || 1;
                    initialMonthsState[module.id] = defaultMonths;
                });

                setFlippedCards(initialFlippedState);
                setModuleSelectedMonths(initialMonthsState);
            }
        } catch (error) {
            console.error('Error fetching modules:', error);
        } finally {
            setLoading(false);
        }
    };

    const toggleModule = (moduleName) => {
        if (selectedModules.includes(moduleName)) {
            setSelectedModules(selectedModules.filter((m) => m !== moduleName));
        } else {
            setSelectedModules([...selectedModules, moduleName]);
        }
    };

    const handleFlip = (moduleId, e) => {
        e.stopPropagation();
        setFlippedCards(prev => ({ ...prev, [moduleId]: !prev[moduleId] }));
    };

    const handleModuleMonthChange = (moduleId, months) => {
        setModuleSelectedMonths(prev => ({ ...prev, [moduleId]: months }));
    };

    const handlePaymentComplete = () => {
        setShowPaymentModal(false);
        setSelectedModuleData([]);
    };

    const getModulePrice = (module) => {
        const months = moduleSelectedMonths[module.id] || 1;
        const priceDetail = module.price_details.find(p => p.no_of_months === months);
        return priceDetail?.total_price || '0.00';
    };

    const getModuleDays = (module) => {
        const months = moduleSelectedMonths[module.id] || 1;
        const priceDetail = module.price_details.find(p => p.no_of_months === months);
        return priceDetail?.days || 30 * months;
    };

    const calculateTotal = () => {
        return modules
            .filter(module => selectedModules.includes(module.name))
            .reduce((sum, module) => sum + parseFloat(getModulePrice(module) || 0), 0);
    };

    const HandleNavigate = () => {
        const preparedData = modules
            .filter(module => selectedModules.includes(module.name))
            .map(module => {
                const months = moduleSelectedMonths[module.id] || module.price_details[0]?.no_of_months || 1;
                const priceDetail = module.price_details.find(p => p.no_of_months === months);

                return {
                    ...module,
                    selectedMonths: months,
                    priceDetail: {
                        ...priceDetail,
                        total_price: priceDetail?.total_price,
                        days: priceDetail?.days,
                        no_of_months: priceDetail?.no_of_months,
                        id: priceDetail?.id
                    },
                };
            });

        if (inModal) {
            setSelectedModuleData(preparedData);
            setShowPaymentModal(true);
            onProceedToPayment?.(preparedData);
        } else {
            navigate("/payment-page", {
                state: {
                    selectedModules: preparedData,
                    storeId
                }
            });
        }
    };

    const renderModuleIcon = (moduleName, icon) => {
        if (icon) {
            const configuredIcon = /^(https?:|data:|blob:)/i.test(icon)
                ? icon
                : `${config.api.host.replace(/\/$/, '')}/${String(icon).replace(/^\//, '')}`;
            const fallback = getModuleIcon(moduleName);
            return <img src={configuredIcon} alt={moduleName} className="feature-icon" onError={(event) => {
                if (event.currentTarget.dataset.fallbackApplied === 'true') return;
                event.currentTarget.dataset.fallbackApplied = 'true';
                event.currentTarget.src = fallback;
            }} />;
        }
        if (moduleName === 'Sales + Inventory') {
            return (
                <div className="dual-icon">
                    <img src={InventoryIcon} alt="Inventory" className="feature-icon inventory-icon" />
                    <img src={SaleIcon} alt="Sales" className="feature-icon sale-icon" />
                </div>
            );
        }

        if (moduleName === 'Timecard + Payroll') {
            return (
                <div className="dual-icon">
                    <img src={PayrollIcon} alt="Payroll" className="feature-icon payroll-icon" />
                    <img src={TimeCardIcon} alt="TimeCard" className="feature-icon timecard-icon" />
                </div>
            );
        }

        const iconSrc = getModuleIcon(moduleName);
        return <img src={iconSrc} alt={moduleName} className="feature-icon" />;
    };

    const getModuleIcon = (moduleName) => {
        switch (moduleName) {
            case 'Lottery': return LotteryIcon;
            case 'Gas': return GasIcon;
            case 'Spends Tracking': return ExpenseIcon;
            case 'Timecard + Payroll': return PayrollIcon;
            case 'Sales + Inventory': return InventoryIcon;
            case 'Cheque': return ChequeIcon;
            case 'Pos':
            case 'POS': return PosIcon;
            case 'General Ledger': return GeneralIcon;
            case 'Legal Manage':
            case 'Legal':return LegalIcon;
            case 'Monitoring': return CameraIcon ;
            case 'Ecommerce' :return EcommerceLogo
            case 'Asset Management' : return AssetsLogo;
            default: return ChequeIcon;
        }
    };

    const isModuleSelected = (moduleName) => selectedModules.includes(moduleName);

    const filteredModules = modules.filter((module) => {
        const query = searchQuery.trim().toLowerCase();
        if (!query) return true;

        return `${module.name} ${module.description}`.toLowerCase().includes(query);
    });

    const renderSelectedModuleItem = (moduleName) => {
        const moduleData = modules.find(m => m.name === moduleName);
        if (!moduleData) return null;

        return (
            <div key={moduleName} className="module-item" style={{ borderBottom: "1px solid #D5D5D5" }}>
                <div className="module-feature-content">
                    <span className="module-feature-name">{moduleName}</span>
                    <span className="module-feature-billing">
                        {getModuleDays(moduleData)} Days
                    </span>
                    <span className="module-feature-price">{formatCurrency(getModulePrice(moduleData))}</span>
                </div>

            </div>
        );
    };

    useEffect(() => {
        fetchModules();
    }, []);

    return (
        <div className="subscription-holder-auth">
            {showPaymentModal && (
                <div>
                    <div className="modal-content" style={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "1680px",
                        height: "auto",
                        maxHeight: "100vh",
                        overflow: "auto",
                        borderRadius: "40px",
                        backgroundColor: "white",
                    }}>
                        <PaymentComponent
                            inModal={true}
                            onComplete={handlePaymentComplete}
                            selectedModules={selectedModuleData}
                            storeId={storeId}
                        />
                    </div>
                </div>
            )}

            {}

            <div className="subscription-content-auth">

                <div className="modules-grid-container">

                    <div className="subscription-hero-auth">
                        <div>
                            <span className="subscription-eyebrow-auth">Choose modules</span>
                            <h1>Build your PaisaVara workspace</h1>
                            <p>Select the apps your store needs today. You can search, compare pricing, and continue only with the modules you choose.</p>
                        </div>
                        <div className="subscription-search-auth">
                            <span aria-hidden="true">⌕</span>
                            <input
                                type="search"
                                value={searchQuery}
                                onChange={(event) => setSearchQuery(event.target.value)}
                                placeholder="Search modules, apps or features..."
                                aria-label="Search subscription modules"
                            />
                        </div>
                    </div>

                    <div className="modules-grid">
                        {loading ? (
                            <div className="subscription-empty-state">Loading features...</div>
                        ) : filteredModules.length === 0 ? (
                            <div className="subscription-empty-state">No modules match your search.</div>
                        ) : (
                            filteredModules.map((module) => (
                                <ReactCardFlip
                                    key={module.id}
                                    isFlipped={flippedCards[module.id]}
                                    flipDirection="horizontal"
                                >
                                    <div
                                        className={`module-box ${isModuleSelected(module.name) ? 'selected' : ''}`}
                                        onClick={() => toggleModule(module.name)}
                                    >
                                        <div className="module-header">
                                            <img
                                                src={infoIcon}
                                                alt="Info"
                                                className="info-icon"
                                                onClick={(e) => handleFlip(module.id, e)}
                                            />
                                            <div className="module-header-content-auth">
                                        {renderModuleIcon(module.name, module.icon)}
                                                <span className="module-name">{module.name}</span>
                                            </div>
                                        </div>

                                        <div className="feature-bottom">
                                            <div className="module-billing-selector">
                                                <div className="dropdown-payment">
                                                    <select
                                                        value={moduleSelectedMonths[module.id] || 1}
                                                        onChange={(e) => handleModuleMonthChange(module.id, Number(e.target.value))}
                                                        className="dropdown-select"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        {module.price_details.map((priceDetail) => (
                                                            <option key={priceDetail.id} value={priceDetail.no_of_months}>
                                                                {priceDetail.no_of_months} {priceDetail.no_of_months > 1 ? "Months" : "Month"}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <img src={ArrowDownIcon} alt="Select" className="Downarrow" />
                                                </div>
                                                <div className="module-price">
                                                    {formatCurrency(getModulePrice(module))}
                                                </div>
                                            </div>

                                            {isModuleSelected(module.name) ? (
                                                <img
                                                    src={RemoveIcon}
                                                    alt={`Remove ${module.name}`}
                                                    className="cart-icon-bottom"
                                                    data-testid={`remove-${generateSafeId(module.name)}`}
                                                    // data-module-name={module.name}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleModule(module.name);
                                                    }}
                                                />
                                            ) : (
                                                <img
                                                    src={CartIcon}
                                                    alt={`Add ${module.name}`}
                                                    className="cart-icon-bottom"
                                                    data-testid={`add-${generateSafeId(module.name)}`}
                                                    // data-module-name={module.name}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleModule(module.name);
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="module-box module-box-back">
                                        <div className="module-header">
                                            <img
                                                src={infoDark}
                                                alt="Back"
                                                className="info-icon"
                                                onClick={(e) => handleFlip(module.id, e)}
                                            />
                                        </div>
                                        <div className="module-description-container">
                                            <h3>{module.name}</h3>
                                            <p className="module-description-text">{module.description}</p>
                                        </div>
                                    </div>
                                </ReactCardFlip>
                            ))
                        )}
                    </div>
                </div>

                <div className="payment-holder-auth">
                       <img src={Cart} alt="Cart Icon" className="cart-icon-top" />
                    <div className="payment-card-auth">
                        <p className="cart-title">Cart</p>
                        <p className="price-texts-auth">{formatCurrency(calculateTotal().toFixed(2))}</p>
                    </div>

                    <div className="selected-modules">
                        {selectedModules.length === 0 ? (
                            <p className="no-feature">No feature selected</p>
                        ) : (
                            selectedModules.map(renderSelectedModuleItem)
                        )}
                    </div>

                    <div>
                        <button
                            className='subscription-btn'
                            data-testid="proceed-to-payment-btn"
                            onClick={HandleNavigate}
                            disabled={selectedModules.length === 0}
                        >
                            View Full Cart
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SubscriptionComponent;
